import script from "./InvoiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceCard.vue?vue&type=style&index=0&id=236cd3cb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236cd3cb"]])

export default __exports__